/************************************** THIRD-PARTY IMPORTS ***************************************/
import React from 'react';
import {BrowserRouter as Router, Switch, Route} from 'react-router-dom';
import {inject, observer} from 'mobx-react';

/**************************************** PROJECT IMPORTS *****************************************/
import {AuthLandingRootContainer} from './auth-landing/auth-landing-root-container';
import {StoreProps, redirectToLogin, LoadMessage} from '@canimmunize/core-imports';

/**************************************** DYNAMIC IMPORTS *****************************************/
import Loadable from 'react-loadable';

const MainClientRouter = Loadable({
    loader: () => import('./main-client/main-client-router').then(cmp => cmp.MainClientRouter),
    loading: LoadMessage,
});

const Error404Screen = Loadable({
    loader: () => import('./error-404-screen/error-404-screen').then(cmp => cmp.Error404Screen),
    loading: LoadMessage,
});

/**************************************** TYPE DEFINITIONS ****************************************/
/**
 * Asynchronously load the Home page and render it, if user is logged in
 */
const HomeAsync = inject('appState')(
    observer((props: StoreProps) => {
        const {appState} = props;

        if (!!appState.accessToken) {
            // Import/dynamic load MainClientRouter component if accessToken present
            return <MainClientRouter />;
        } else if (appState.modelInitStatusStore.isStoreInitialized) {
            redirectToLogin();
        }

        return null;
    })
);

/********************************************* EXPORT *********************************************/
/**
 * Component providing the top-level router for the app
 * Determines which subapp to render (pre-login or post-login)
 * Very 1st item to render within the entry component
 *
 * Prefetches main client bundle
 */
@inject('appState')
@observer
export class TopLevelRouter extends React.Component<StoreProps> {
    componentDidMount() {
        MainClientRouter.preload();
        Error404Screen.preload();
    }

    render() {
        return (
            <Router>
                <Switch>
                    <Route path="/auth/:lang/forgot-password-fail" component={Error404Screen} />
                    <Route path="/auth" component={AuthLandingRootContainer} />
                    <Route path="/main" component={HomeAsync} />
                    <Route default component={Error404Screen} />
                </Switch>
            </Router>
        );
    }
}
